import { CommonAPIService } from "src/servicehandlers/CommonHandler";

export class InspectionsAPIService {
  constructor() {
    this.CommonAPIService = new CommonAPIService();
  }

  get(router) {
    const url = "/api/inspections";
    return this.CommonAPIService.getCall(url, null, router);
  }

  getById(id, router) {
    const url = `/api/inspections/${id}`;
    return this.CommonAPIService.getCall(url, null, router);
  }

  getByAircraftId(aircraftId, router) {
    const url = `/api/inspections/aircraft/${aircraftId}`;
    return this.CommonAPIService.getCall(url, null, router);
  }

  getInspectionTypes(router) {
    const url = "/api/inspections/inspectionTypes";
    return this.CommonAPIService.getCall(url, null, router);
  }

  create(params, router) {
    const url = "/api/inspections";
    return this.CommonAPIService.postCall(url, params, router);
  }

  delete(id, router) {
    const url = `/api/inspections/${id}`;
    return this.CommonAPIService.deleteCall(url, null, router);
  }

  update(id, params, router) {
    const url = `/api/inspections/${id}`;
    return this.CommonAPIService.postCall(url, params, router);
  }
}
export default InspectionsAPIService;
